import { useAutoneTranslation } from '@autone/translations';
import { ListFilter } from 'lucide-react';
import { forwardRef } from 'react';

import { Button, type ButtonProps, cn } from '../../../tailwind';

import { useActiveFiltersCount } from './hooks';

export const FiltersButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    const { common } = useAutoneTranslation();
    const { activeFiltersCount } = useActiveFiltersCount();
    return (
      <Button
        variant="outlined"
        color={activeFiltersCount ? 'primary' : 'secondary'}
        className={cn('h-[34px]', className)}
        ref={ref}
        {...props}
      >
        <ListFilter size={18} className={'mr-2'} />
        {common('filters.header')}
        {activeFiltersCount ? ` (${activeFiltersCount})` : ''}
      </Button>
    );
  },
);
